import { parseCookies } from '@cian/utils/lib/shared/cookie';

type TNewbuildingBannerTestCookie = 'broker' | 'prize';

const NEWBUILDING_BANNER_TEST_COOKIE_NAME = 'newbuilding_search_banner_test';

/**
 * Используется QA для ui тестов
 */
export function getNewbuildingBannerTestCookie(): TNewbuildingBannerTestCookie | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const cookie = parseCookies(window.document.cookie)[NEWBUILDING_BANNER_TEST_COOKIE_NAME];

  return cookie === 'broker' || cookie === 'prize' ? cookie : null;
}
